import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgCoin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    {...props}
    width={72}
    height={74}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <g clipPath="url(#coin_svg__a)">
      <path
        d="M64.776 66.15c-.985 4.075-12.418 7.58-25.522 7.85-13.105.27-22.896-2.816-21.91-6.86.984-4.075 12.417-7.58 25.522-7.85 13.074-.27 22.895 2.786 21.91 6.86Z"
        fill="#E0BFAD"
      />
      <path
        d="M71.672 39.215c.985-7.1-.18-14.5-3.762-20.762-1.164-2.037-2.537-3.924-4.149-5.602-1.82-1.917-3.88-3.595-5.85-5.363 5.432 4.824 8.835 11.625 9.79 18.815.986 7.22-.447 14.83-3.79 21.301-3.314 6.441-8.21 11.924-14.329 15.789-6.06 3.835-13.134 5.962-20.328 5.782-6.538-.21-12.956-2.397-18.09-6.501-.388-.3-.746-.63-1.134-.959 2.597 2.307 5.104 4.764 8.06 6.591 2.716 1.678 5.73 2.876 8.835 3.625 6.896 1.618 14.21.81 20.717-1.887 6.507-2.697 12.238-7.19 16.477-12.823 4-5.303 6.657-11.504 7.553-18.006Z"
        fill="url(#coin_svg__b)"
      />
      <path
        opacity={0.5}
        d="M47.731 70.014a36.761 36.761 0 0 0 6.508-3.475l-2.478-2.637c-.298.21-.597.39-.895.6-6.18 3.924-13.403 6.081-20.747 5.872-5.194-.15-10.328-1.558-14.806-4.165.926.72 1.881 1.438 2.896 2.037 2.716 1.678 5.731 2.877 8.836 3.626 6.836 1.617 14.15.838 20.686-1.858Z"
        fill="url(#coin_svg__c)"
        fillOpacity={0.5}
      />
      <path
        d="M41.134.179c18.359 1.947 30.06 18.904 26.15 37.929-3.94 18.994-22 32.835-40.388 30.888C8.537 67.048-3.164 50.09.746 31.067 4.686 12.073 22.776-1.769 41.134.18Z"
        fill="url(#coin_svg__d)"
      />
      <path
        opacity={0.2}
        d="M41.015.986C23.283-.9 5.82 12.461 2.03 30.796a34.742 34.742 0 0 0-.627 4.194c7.433 5.393 16.418 8.928 26.507 9.977 13.463 1.408 26.836-1.798 38.508-8.419 3.194-17.916-8-33.734-25.403-35.562Z"
        fill="url(#coin_svg__e)"
      />
      <path
        opacity={0.5}
        d="M29.701 67.378C13.314 65.64 1.373 51.319 5.075 33.523c3.671-17.766 20.597-30.708 37.76-28.91 14.419 1.527 22.866 13.72 23.493 27.203.717-15.999-10.03-29.42-26-31.128C22.538-1.17 5.015 12.222 1.224 30.618c-3.821 18.394 7.522 34.842 25.313 36.73 1.612.18 3.224.21 4.836.15-.567-.03-1.134-.09-1.672-.12Z"
        fill="#94512A"
      />
      <path
        d="M38.478 3.864c1.044 0 2.09.06 3.104.15 7.672.81 14.299 4.584 18.687 10.606a27.503 27.503 0 0 1 4.657 10.636c.835 4.104.805 8.358-.09 12.702-1.612 7.82-5.97 15.04-12.269 20.313-6.239 5.213-13.82 8.089-21.373 8.089-1.045 0-2.09-.06-3.104-.15-7.672-.809-14.299-4.584-18.687-10.605a27.502 27.502 0 0 1-4.657-10.636c-.835-4.105-.806-8.359.09-12.703 1.612-7.82 5.97-15.04 12.269-20.313 6.238-5.212 13.82-8.089 21.373-8.089Zm0-2.966C21.522.928 5.582 14.051 1.94 31.667-1.94 50.452 9.642 65.76 27.791 67.678c1.134.12 2.269.18 3.403.18 16.955 0 31.523-12.613 35.164-30.23 3.88-18.784-6.328-34.602-24.477-36.52a25.944 25.944 0 0 0-3.403-.21Z"
        fill="#E99855"
      />
      <path
        d="M37.702 2.996c1.044 0 2.09.06 3.134.15 7.761.809 14.448 4.614 18.895 10.725 2.299 3.176 3.881 6.801 4.717 10.756.866 4.134.836 8.448-.09 12.852-1.642 7.91-6.03 15.19-12.418 20.523-6.298 5.273-13.97 8.179-21.582 8.179-1.044 0-2.09-.06-3.134-.15-7.731-.81-14.448-4.614-18.896-10.726-2.298-3.175-3.88-6.8-4.716-10.755-.866-4.135-.836-8.449.09-12.853 1.611-7.91 6.03-15.22 12.388-20.522 6.298-5.273 13.97-8.18 21.612-8.18Zm0-2.996C20.567 0 4.448 13.272.745 31.068c-3.94 18.994 7.761 35.981 26.15 37.929 1.164.12 2.298.18 3.462.18 17.135 0 33.254-13.273 36.926-31.069 3.94-18.994-7.762-35.98-26.15-37.928A32.939 32.939 0 0 0 37.702 0Z"
        fill="url(#coin_svg__f)"
      />
      <path
        opacity={0.7}
        d="M41.134.18A32.935 32.935 0 0 0 37.701 0C20.567 0 4.448 13.272.746 31.068a38.798 38.798 0 0 0-.657 4.764c.956.659 1.91 1.288 2.896 1.917.03-2.007.269-4.015.686-6.052 1.642-7.91 6.06-15.22 12.418-20.522 6.299-5.273 13.97-8.18 21.612-8.18 1.045.001 2.09.06 3.135.15 7.76.81 14.447 4.615 18.895 10.726 2.299 3.176 3.88 6.801 4.717 10.756.865 4.134.835 8.448-.09 12.852-.09.36-.15.72-.239 1.079a125.04 125.04 0 0 0 3.433-1.858C70.627 18.275 59.045 2.067 41.134.18Z"
        fill="url(#coin_svg__g)"
      />
      <path
        d="M41.254 18.064c4.18.45 6.866 2.726 8.06 6.83.09.33-.09.72-.418.84l-4.03 1.408c-.09.03-.209.03-.299.03-.179-.03-.328-.12-.358-.33-.328-2.396-1.582-3.715-3.731-3.924-1.314-.15-2.448.24-3.403 1.048-.955.839-1.642 2.187-2 3.985-.239 1.138-.329 2.636-.269 4.314 0 .42.21.929.597.959l4.866.509c.09 0 .15 0 .239.03.238.03.447.09.388.33l-.687 3.325c-.06.36-.567 1.019-.895.989l-4.866-.51c-.09 0-.209-.03-.298-.03-.18-.03-.299 0-.359.21-.537 2.517-1.104 4.075-1.79 5.243-.657 1.108-1.762 2.157-3.344 3.355-.18.15-.06.18.15.21l5.76.6c3.314.359 5.523.389 6.747-.36 1.074-.66 1.82-1.408 2.328-2.727.09-.21.298-.329.478-.3.06 0 .12.03.179.06l3.76 2.667c.27.18.36.48.18.78-.985 1.617-2.06 2.875-3.254 3.864-1.313 1.108-2.627 1.708-4.03 2.097-1.402.39-3.164.21-5.432-.03l-18-1.887c-.18-.03-.448 0-.687-.03-.209-.03-.358-.09-.328-.24l.955-4.614c.06-.33.597-.569.925-.539 1.761.12 3.344.09 4.329-.15 1.074-.27 2.06-.898 3.044-1.977.956-1.079 1.582-2.217 1.851-3.535.12-.6.239-1.498.388-2.936.03-.36-.239-.45-.567-.48l-2.686-.27c-.329-.03-.389-.778-.329-1.138l.687-3.325c.06-.27.179-.27.388-.27.06 0 .149.03.209.03l2.149.24c.328.03.657-.48.687-.81.119-1.617.298-3.025.477-3.864.657-3.116 2.12-5.602 4.388-7.4 2.239-1.828 4.896-2.576 7.851-2.277Z"
        fill="#94512A"
        opacity={0.5}
      />
      <path
        d="m24.12 35.74 2.656.27c.18.03.358.06.478.15l-1.88-1.678c-.09-.09-.27-.12-.478-.15l-1.94.06c-.06 0-.12.3-.15.27L24 35.71c.03 0 .06.03.12.03Z"
        fill="url(#coin_svg__h)"
      />
      <path
        d="M32.328 26.512c-.06.57-.09 1.168-.09 1.738 0 .569-.089 1.258.15 1.797.03.09.06.3.15.36l1.94 1.588c-.478-.45-.329-1.379-.329-1.948 0-.749.06-1.498.15-2.217.178-1.438.596-2.996 1.492-4.164.746-.989 1.85-1.648 3.075-1.768 1.134-.12 2.417.18 3.283.959l-1.552-1.378c-.448-.42-.896-.75-1.493-.989-1.194-.45-2.567-.39-3.701.21-2.12 1.078-2.836 3.595-3.075 5.812.03-.12 0 .06 0 0Z"
        fill="url(#coin_svg__i)"
      />
      <path
        d="M30.985 36.342c-.299 1.258-.687 2.516-1.284 3.655a10.227 10.227 0 0 1-1.612 2.127c-.358.33-.716.66-1.104.989-.299.24-.627.449-.896.719l-.03.03v.06c.329.3.657.599.986.868.179.15.328.3.507.45.09.06.18.15.239.21.03.03.179.21.15.12v-.03c0-.03.029-.03.029-.03.269-.3.657-.51.985-.78.388-.3.746-.629 1.075-.988.627-.63 1.164-1.288 1.552-2.067.418-.72.687-1.558.925-2.337.12-.42.24-.87.358-1.319.06-.21.09-.419.15-.629.03-.18.06-.42.149-.569.09-.18.448-.06.597-.06l4.836.51c.15.03.298-.12.418-.21a2.4 2.4 0 0 0 .448-.63c.03-.06.03-.09.06-.15l.686-3.295c0-.06.03-.15-.03-.21l-.03-.03-1.403-1.138s.06.03.09.03c.03.06-.21-.09-.21-.03l-.984 2.966c-.03.21-.18.39-.299.57-.12.18-.358.449-.597.419l-4.836-.51c-.149 0-.268-.06-.418-.03-.03 0-.06 0-.09.03l-.029.03c-.06.03-.06.12-.09.15-.119.36-.209.75-.298 1.109.03-.15 0 .03 0 0Z"
        fill="url(#coin_svg__j)"
      />
      <path
        d="M48.567 24.027c0-.27-.149-.569-.239-.809-.119-.33-.238-.659-.388-.958a10.79 10.79 0 0 0-.925-1.618c-.836-1.199-2.03-2.097-3.104-3.056.746.659 1.343 1.468 1.82 2.337.24.45.448.899.627 1.378.15.36.418.869.299 1.288a.634.634 0 0 1-.418.45l-3.85 1.497c-.18.06.059.51-.06.39l1.283 1.139c.15.12.358.12.537.06l4-1.409c.12-.03.24-.12.299-.24.06-.18.12-.299.12-.449Z"
        fill="url(#coin_svg__k)"
      />
      <path
        d="M47.522 46.078c0-.06-.03-.15-.06-.21-.03-.03-.06-.09-.089-.12-.269-.3-.597-.54-.895-.809-.359-.33-.717-.629-1.075-.959.448.39.03.87-.209 1.259-.388.599-.836 1.198-1.313 1.737-.926 1.079-2 2.008-3.254 2.697-1.105.599-2.329 1.048-3.582 1.138-1.373.09-2.776-.09-4.15-.21l-17.85-1.887c-.269-.03-.12.66-.358.45.477.419.328.27.776.688.209.18.447.39.716.45.239.06.508.09.746.12l17.851 1.887c1.343.15 2.716.3 4.06.21 1.283-.09 2.507-.51 3.642-1.139 1.164-.629 2.179-1.498 3.044-2.486a20.42 20.42 0 0 0 1.254-1.558c.18-.27.388-.57.567-.839.12-.15.21-.27.18-.42Z"
        fill="url(#coin_svg__l)"
      />
      <path
        d="M39.254 15.966c4.149.45 6.806 2.697 8 6.771.09.33-.09.72-.418.81l-4 1.407c-.09.03-.21.03-.299.03-.179-.03-.328-.12-.358-.3-.328-2.366-1.552-3.684-3.702-3.894-1.283-.15-2.417.24-3.373 1.049-.955.808-1.612 2.157-2 3.924-.239 1.109-.328 2.607-.268 4.284 0 .39.209.93.597.96l4.836.508c.09 0 .149 0 .238.03.24.03.448.09.388.33l-.686 3.295c-.06.33-.567 1.02-.896.99l-4.836-.51c-.09 0-.208-.03-.298-.03-.18-.03-.299 0-.358.21-.538 2.516-1.105 4.044-1.791 5.183-.657 1.108-1.762 2.127-3.314 3.325-.179.15-.06.18.15.21l5.73.599c3.284.36 5.464.36 6.687-.36 1.075-.659 1.791-1.378 2.299-2.696.09-.21.298-.33.478-.3.06 0 .119.03.179.06l3.731 2.667c.269.18.358.48.18.779-.986 1.618-2.03 2.846-3.225 3.835a10.049 10.049 0 0 1-4 2.067c-1.373.39-3.134.21-5.373-.03l-17.85-1.888c-.18-.03-.448 0-.687-.03-.21-.03-.358-.09-.329-.24l.956-4.583c.06-.33.597-.57.895-.54 1.761.12 3.314.09 4.269-.12 1.045-.269 2.06-.898 3.015-1.976.955-1.079 1.552-2.188 1.82-3.506.12-.569.24-1.468.389-2.906.03-.36-.24-.45-.568-.48l-2.656-.269c-.329-.03-.388-.779-.329-1.108l.687-3.296c.06-.27.18-.27.388-.27.06 0 .12.03.209.03l2.15.24c.328.03.656-.45.656-.809.12-1.617.299-2.996.478-3.834.627-3.086 2.09-5.543 4.358-7.34 2.269-1.828 4.895-2.577 7.85-2.277Z"
        fill="url(#coin_svg__m)"
      />
      <path
        d="M37.97 15.906v.87c.388 0 .776.029 1.194.059 3.761.39 6.12 2.367 7.224 5.992l-3.433 1.198c-.627-3.056-2.686-3.894-4.388-4.074-.209-.03-.418-.03-.597-.03-1.283 0-2.418.42-3.403 1.288-1.104.929-1.85 2.427-2.269 4.404-.238 1.229-.358 2.756-.298 4.464.03.809.478 1.708 1.343 1.798l4.567.479-.537 2.636c-.03.09-.12.21-.209.3l-4.597-.48c-.03 0-.09 0-.12-.03-.059 0-.119-.03-.178-.03h-.18c-.537 0-.984.36-1.104.9-.507 2.306-1.015 3.834-1.672 4.913-.567.929-1.522 1.887-3.104 3.086-.508.39-.418.898-.388 1.048.09.27.298.63.955.69l5.731.599c1.553.15 2.717.24 3.642.24 1.612 0 2.746-.24 3.553-.72 1.164-.719 1.94-1.528 2.447-2.666l3.105 2.217c-.866 1.378-1.821 2.486-2.896 3.385-1.104.929-2.268 1.528-3.671 1.918-.478.12-1.075.18-1.791.18-.956 0-2.06-.12-3.284-.24l-17.85-1.888h-.09l.746-3.655c.03 0 .03 0 .06-.03.716.06 1.373.09 2 .09 1.074 0 1.91-.09 2.537-.24 1.254-.329 2.358-1.048 3.433-2.216 1.074-1.199 1.731-2.457 2.03-3.895.149-.66.238-1.618.388-2.996.12-1.199-1.075-1.408-1.344-1.408l-2.238-.24v-.15l.597-2.816 1.91.21h.12c.895 0 1.432-.929 1.492-1.618.12-1.468.269-2.846.448-3.715.597-2.876 1.97-5.183 4.06-6.86 1.76-1.409 3.79-2.128 6.03-2.128l.03-.839Zm0 0c-2.448 0-4.627.78-6.567 2.307-2.269 1.798-3.731 4.254-4.358 7.34-.18.84-.358 2.217-.478 3.835-.03.33-.328.809-.627.809h-.03l-2.149-.24c-.09 0-.15-.03-.209-.03h-.12c-.148 0-.238.06-.298.27l-.686 3.296c-.06.329 0 1.078.328 1.108l2.657.27c.328.03.597.12.567.479-.15 1.438-.269 2.337-.388 2.906-.269 1.288-.866 2.427-1.821 3.505-.955 1.079-1.94 1.708-3.015 1.978-.597.15-1.403.21-2.328.21-.597 0-1.254-.03-1.94-.06h-.06c-.329 0-.806.21-.866.539l-.955 4.584c-.03.18.12.24.328.24.21.03.508 0 .687.03l17.85 1.887c1.284.12 2.389.24 3.374.24.746 0 1.403-.06 2-.21 1.373-.39 2.686-.99 4-2.068 1.164-.988 2.239-2.217 3.224-3.834.179-.3.09-.6-.18-.78l-3.73-2.666a.423.423 0 0 0-.18-.06h-.03c-.179 0-.358.12-.448.3-.507 1.288-1.224 2.037-2.298 2.696-.717.42-1.731.6-3.134.6-1.015 0-2.18-.09-3.583-.24l-5.73-.6c-.21-.03-.33-.06-.15-.21 1.552-1.198 2.657-2.216 3.313-3.325.687-1.138 1.254-2.696 1.791-5.183.03-.18.15-.21.269-.21h.09c.09 0 .179.03.298.03l4.836.51h.03c.328 0 .806-.66.865-.989l.687-3.295c.06-.27-.15-.33-.388-.33-.09 0-.15 0-.239-.03l-4.836-.51c-.388-.03-.567-.568-.597-.958-.06-1.678.06-3.146.269-4.284.358-1.768 1.045-3.116 2-3.925.836-.719 1.761-1.078 2.836-1.078.179 0 .358 0 .507.03 2.15.24 3.373 1.528 3.702 3.894.03.18.179.3.358.3h.06c.06 0 .149 0 .238-.03l4-1.408c.329-.12.508-.51.418-.809-1.194-4.074-3.85-6.321-8-6.77-.328-.03-.746-.06-1.164-.06Z"
        fill="url(#coin_svg__n)"
        opacity={0.1}
      />
      <path
        d="M23.82 41.822c-.208.21-.387.419-.596.599 1.164.18 2.328.36 3.492.48.538.06 1.045.089 1.582.149.747-.69 1.314-1.348 1.732-2.037.686-1.139 1.253-2.697 1.79-5.183.03-.21.18-.24.359-.21.09 0 .179.03.298.03l4.836.51c.329.03.806-.66.896-.99l.686-3.295c.06-.27-.149-.33-.388-.33-.09 0-.149 0-.238-.03l-4.836-.509c-.388-.03-.568-.569-.597-.959-.06-1.677.06-3.145.268-4.284.358-1.767 1.045-3.116 2-3.924.956-.84 2.09-1.199 3.373-1.049 2.15.24 3.374 1.528 3.702 3.895.03.18.179.3.358.3.09 0 .18 0 .299-.03l4-1.409c.328-.12.507-.509.418-.809-1.194-4.074-3.851-6.321-8-6.77-2.956-.3-5.553.449-7.821 2.246-2.269 1.798-3.732 4.255-4.358 7.34-.18.84-.359 2.218-.478 3.835-.03.36-.329.84-.657.81l-2.15-.24c-.089 0-.148-.03-.208-.03-.209-.03-.328 0-.388.27l-.687 3.295c-.06.33 0 1.078.329 1.108l2.656.27c.329.03.597.12.567.48-.149 1.437-.268 2.336-.387 2.905-.299 1.349-.896 2.487-1.851 3.566Z"
        fill="url(#coin_svg__o)"
        opacity={0.5}
      />
      <path
        d="m29.731 20.102 2.06.569-1.85-1.079-.18-.54.567-2.126-1.074 1.917-.508.21-2.06-.6 1.851 1.11.21.509-.598 2.157 1.075-1.918.507-.21Z"
        fill="#fff"
      />
    </g>
    <defs>
      <linearGradient
        id="coin_svg__b"
        x1={78.715}
        y1={-26.628}
        x2={18.317}
        y2={98.821}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD243" />
        <stop offset={1} stopColor="#CD571B" />
      </linearGradient>
      <linearGradient
        id="coin_svg__c"
        x1={43.322}
        y1={48.46}
        x2={27.719}
        y2={80.869}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E08C3C" />
        <stop offset={1} stopColor="#FFD06F" />
      </linearGradient>
      <linearGradient
        id="coin_svg__d"
        x1={15.317}
        y1={128.648}
        x2={56.827}
        y2={-78.602}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5942A" />
        <stop offset={1} stopColor="#F5D85D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__e"
        x1={24.052}
        y1={84.891}
        x2={51.186}
        y2={-50.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E08C3C" />
        <stop offset={1} stopColor="#FFD06F" />
      </linearGradient>
      <linearGradient
        id="coin_svg__f"
        x1={47.511}
        y1={-18.8}
        x2={11.99}
        y2={120.748}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.199} stopColor="#FFDE43" />
        <stop offset={0.565} stopColor="#FFD23E" />
        <stop offset={1} stopColor="#FFBD37" />
      </linearGradient>
      <linearGradient
        id="coin_svg__g"
        x1={45.771}
        y1={-12.176}
        x2={22.641}
        y2={78.695}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.018} stopColor="#FFFFA0" />
        <stop offset={0.976} stopColor="#FFEB6A" />
      </linearGradient>
      <linearGradient
        id="coin_svg__h"
        x1={15.264}
        y1={24.277}
        x2={40.865}
        y2={53.248}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.086} stopColor="#CD553F" />
        <stop offset={0.905} stopColor="#FFD067" />
        <stop offset={1} stopColor="#FFC46D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__i"
        x1={24.271}
        y1={11.739}
        x2={55.09}
        y2={46.616}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.086} stopColor="#CD553F" />
        <stop offset={0.905} stopColor="#FFD067" />
        <stop offset={1} stopColor="#FFC46D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__j"
        x1={16.106}
        y1={18.959}
        x2={46.924}
        y2={53.835}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.086} stopColor="#CD553F" />
        <stop offset={0.905} stopColor="#FFD067" />
        <stop offset={1} stopColor="#FFC46D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__k"
        x1={30.354}
        y1={6.367}
        x2={61.172}
        y2={41.243}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.086} stopColor="#CD553F" />
        <stop offset={0.905} stopColor="#FFD067" />
        <stop offset={1} stopColor="#FFC46D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__l"
        x1={11.352}
        y1={24.956}
        x2={45.516}
        y2={63.619}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.086} stopColor="#CD553F" />
        <stop offset={0.266} stopColor="#CE5840" />
        <stop offset={0.41} stopColor="#D26243" />
        <stop offset={0.543} stopColor="#D97349" />
        <stop offset={0.668} stopColor="#E38B51" />
        <stop offset={0.786} stopColor="#EFA95A" />
        <stop offset={0.901} stopColor="#FECE67" />
        <stop offset={0.905} stopColor="#FFD067" />
        <stop offset={1} stopColor="#FFC46D" />
      </linearGradient>
      <linearGradient
        id="coin_svg__m"
        x1={40.904}
        y1={5.296}
        x2={22.149}
        y2={78.976}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.164} stopColor="#FFDE43" />
        <stop offset={0.248} stopColor="#FFDA42" />
        <stop offset={1} stopColor="#FFBD37" />
      </linearGradient>
      <linearGradient
        id="coin_svg__n"
        x1={14.688}
        y1={33.664}
        x2={47.273}
        y2={33.664}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.164} stopColor="#FFDE43" />
        <stop offset={0.248} stopColor="#FFDA42" />
        <stop offset={1} stopColor="#FFBD37" />
      </linearGradient>
      <linearGradient
        id="coin_svg__o"
        x1={40.034}
        y1={7.556}
        x2={25.52}
        y2={64.575}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.018} stopColor="#FFFFA0" />
        <stop offset={0.976} stopColor="#FFEB6A" />
      </linearGradient>
      <clipPath id="coin_svg__a">
        <path fill="#fff" d="M0 0h72v74H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgCoin);
export default ForwardRef;
